// 如何使用
// 
// /App.vue
// import mixin_toggleFullScreen from '@/mixins/mixin_toggleFullScreen'
// mixins: [mixin_toggleFullScreen],
// 
export default {
  data() {
    return {
      full_screen: false,
    }
  },
  methods: {
    // 切換全屏
    _togglo_full_screen() {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        if(document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if(document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if(document.msCancelFullScreen) {
          document.msCancelFullScreen()
        }
        this.full_screen = false
      } else {
        let body = document.querySelector('body')
        if(body.requestFullScreen) {
          body.requestFullScreen()
        } else if(body.webkitRequestFullScreen) {
          body.webkitRequestFullScreen()
        } else if(body.mozRequestFullScreen) {
          body.mozRequestFullScreen()
        } else if(body.msRequestFullScreen) {
          body.msRequestFullScreen()
        }
        this.full_screen = true
      }
    },
  },
  created() {
    if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
      this.full_screen = true
    } else {
      this.full_screen = false
    }
    // console.log(`%c是否全屏:`, 'color: #f00;', this.full_screen)
  },
}